import React, { useState } from 'react';
import { InputGroup, DropdownButton, Dropdown, FormControl } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { searchCompaniesData } from '../../pages/Companies/redux/action';

function SearchHeader() {
  const dispatch = useDispatch();

  const [selectedItem, setSelectedItem] = useState('Companies'); // State for the selected item
  const [inputValue, setInputValue] = useState(''); // State for the selected item

  const handleDropdownSelect = (eventKey) => {
    setSelectedItem(eventKey);
    setInputValue('');
    dispatch(searchCompaniesData('', eventKey));
  };

  const handleInputChange = (e) => {
    const inputValueText = e.target.value;
    setInputValue(inputValueText);
    dispatch(searchCompaniesData(inputValueText, selectedItem));
  };

  return (
    <div className="row" style={{ position: 'relative', zIndex: 1000 }}>
    
     
      <div className="col-md-12" style={{marginLeft:"120px"}}>
        <InputGroup className="mb-10" style={{width:"932px"}} >
          <DropdownButton
            variant="outline-secondary"
            title={selectedItem}
            className="drpdown"
            id="input-group-dropdown-1"
            style={{
              border: '1px solid rgb(204, 204, 204)',
              fontSize: 'medium',
              zIndex: 8000, // Set a higher z-index value if needed
            }}
            onSelect={handleDropdownSelect}
          >
            <Dropdown.Item eventKey="Companies">Companies</Dropdown.Item>
            <Dropdown.Item eventKey="Jobs">Jobs</Dropdown.Item>
            <Dropdown.Item eventKey="Contacts">Contacts</Dropdown.Item>
          </DropdownButton>
          <FormControl
          
            aria-label="Text input with dropdown button"
            placeholder={`Search ${selectedItem}`}
            style={{
              // width: '787px',
              padding: '8px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              boxSizing: 'border-box',
              alignContent: 'center',
              fontSize: 'small',
              height:"45px"
            }}
            value={inputValue}
            onChange={handleInputChange}
          />
        </InputGroup>
      </div>
    </div>
  );
}

export default SearchHeader;
